import client from 'axiosConfig'

const DomainServices = {
  getDomainDetails(id: (number | string)[]) {
    return client.get(
      `/domain_division_region?domain_division_region_id__in=${id}`
    )
  },
}

export default DomainServices
